<template>
  <div class="ticket-romancecar mb-foot-2button">
    <!-- ヘッダー -->
    <MFITTHeader header-title="購入内容確認" />

    <hr />

    <!-- 予約/購入情報-->
    <div class="content-block ticket-info-block">
      <div class="block">
        <!-- 乗車日 -->
        <ViBoardingDate :boarding-date="myLimitedExpressTicket.boarding_date" />

        <!-- 列車名 -->
        <ViTrainInfo
          :name="myLimitedExpressTicket.train.name"
          :cars-formation-name="
            myLimitedExpressTicket.train.cars_formation.name
          "
        />

        <!-- 区間 -->
        <ViStationSection
          :from="myLimitedExpressTicket.from_station.name"
          :to="myLimitedExpressTicket.to_station.name"
        />

        <!-- 時間 -->
        <ViDepartureAndArrival
          :departure="myLimitedExpressTicket.departure_at"
          :arrival="myLimitedExpressTicket.arrival_at"
        />

        <!-- 座席種類 -->
        <StoreSeatType
          :selected-seats="myLimitedExpressTicket.seats"
          :selected-exclusive-cars="
            myLimitedExpressTicket.train.cars_formation.cars
          "
        />

        <!-- 座席 -->
        <StoreSeats
          :seats="myLimitedExpressTicket.seats"
          :is-purchased="
            myLimitedExpressTicket.ticketing_status == '02' ||
            myLimitedExpressTicket.ticketing_status == '04'
          "
        />

        <!-- 運賃表示 -->
        <!-- サルーン以外は大人料金*大人人数+子供料金*子供人数 -->
        <!-- サルーンは大人料金*選択した席数 -->
        <StoreTicketPrice
          v-if="!isSaloon"
          :total-price="
            ticketPrice.limited_express_ticket_adult_price *
              myLimitedExpressTicket.adult_count +
            ticketPrice.limited_express_ticket_child_price *
              myLimitedExpressTicket.child_count
          "
        />
        <StoreTicketPrice
          v-else
          :total-price="
            ticketPrice.limited_express_ticket_adult_price *
            Math.ceil(
              (myLimitedExpressTicket.adult_count +
                myLimitedExpressTicket.child_count) /
                4
            )
          "
        />

        <StoreSelectedPaymentMethod :payment-method="paymentMethod" />

        <!-- クレカ情報 -->
        <!-- <StoreCardInfo :cardInfo="creditCard" /> -->
      </div>
    </div>

    <div class="bottom-note">
      <p class="caution-note-bottom">
        ※必ず次に開く画面で決済を行ってください。
      </p>
      <p class="caution-note-bottom">
        決済が完了するまでブラウザの「戻る」ボタンを押さないでください。
      </p>
    </div>

    <!-- アクションボタン -->
    <div class="foot-button-block">
      <ItemButton
        action-type="btn-primary"
        label="上記の内容で決済に進む"
        @clicked="ticketPurchase"
      />
      <ItemButton
        action-type="btn-cancel"
        label="戻る"
        @clicked="backToPreviousPage"
      />
    </div>
  </div>

  <!-- 予約自動取り消し後、購入不可のダイアログ -->
  <DialogCanNotPurchaseAfterCanceled ref="DialogCanNotPurchaseAfterCanceled" />

  <!-- ローディングダイアログ -->
  <DialogLoading ref="DialogLoading" :timeout-seconds="21000" />

  <!-- 電波状況が悪い場合のダイアログ　-->
  <DialogBadReception ref="DialogBadReception" />

  <DialogDuringMaintenance ref="DialogDuringMaintenance" />

  <DialogUnexpectedError ref="DialogUnexpectedError" />
  <DialogPurchaseWarning ref="DialogPurchaseWarning" />
  <DialogGeneralPuchaseWarning ref="DialogGeneralPuchaseWarning" />
</template>

<script>
import { computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

import API from "@/API";
import routerJS from "@/router";
import storeJS from "@/store";
import nativeHandlerService from "@/services/nativeHandler";

window.jcExpressTicketReceivePayment = function (url) {
  console.log("TemplateMfittMyTicketPurchase");
  const params = new window.URL(url).searchParams;
  const processId = params.get("process_id");
  const result = params.get("result");

  if (
    !url.includes("sbps_express_purchase") ||
    !processId ||
    !["cancel", "success", "error"].includes(result)
  ) {
    return;
  }

  storeJS.commit("MFITT/setPaymentResult", {
    processId,
    result,
  });
};

export default {
  name: "TemplateMfittMyTicketPurchase",
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    store.commit("MFITT/setPaymentResult", null);

    const DialogCanNotPurchaseAfterCanceled = ref(null);
    const DialogPurchaseWarning = ref(null);
    const DialogLoading = ref(null);
    const DialogBadReception = ref(null);
    const DialogUnexpectedError = ref(null);
    const DialogDuringMaintenance = ref(null);
    const DialogGeneralPuchaseWarning = ref(null);

    // const creditCard = computed(() => store.getters["common/CreditCard"]);
    const myLimitedExpressTicket = computed(
      () => store.getters["MFITT/myLimitedExpressTicket"]
    );

    const ticketPrice = computed(() => store.getters["MFITT/ticketPrice"]);

    const isSaloon = computed(() => {
      // 複数座席種別が混在することはないので、先頭だけみる
      var seatAttribute = myLimitedExpressTicket.value.seats[0].seat_attribute;
      return (
        seatAttribute == "A" || seatAttribute == "B" || seatAttribute == "C"
      );
    });

    const selectedPaymentMethod = computed(
      () => store.getters["MFITT/selectedPaymentMethod"]
    );

    const paymentMethods = computed(
      () => store.getters["MFITT/paymentMethods"]
    );

    const paymentMethod = computed(
      () =>
        paymentMethods.value?.find(
          (method) => method.id === selectedPaymentMethod.value
        )?.name
    );

    const paymentResult = computed(() => store.getters["MFITT/paymentResult"]);

    const ticketPurchase = async () => {
      // ローディングダイアログ
      // DialogLoading.value.openDialog();
      const params = {
        ticketing_status: "issued",
        id: myLimitedExpressTicket.value.id,
        authorization_method_id: selectedPaymentMethod.value,
        return_url: process.env.VUE_APP_SBPS_EXPRESS_PURCHASE_SUCCESS,
        error_url: process.env.VUE_APP_SBPS_EXPRESS_PURCHASE_ERROR,
        cancel_url: process.env.VUE_APP_SBPS_EXPRESS_PURCHASE_CANCEL,
      };

      try {
        openPurchaseWarningDialog();
        let response = await API.putTicketingStatus(
          myLimitedExpressTicket.value.id,
          "purchase",
          params
        );

        if (response && response.url != null && response.url != "") {
          nativeHandlerService.ncOpenExternalUrl(response.url);
        }
      } catch (e) {
        // Handle General Purchase Error
        closePurchaseWarningDialog();
        console.log("General Purchase Error in MFITT Booking", e);
        DialogGeneralPuchaseWarning.value.openDialog();
      }
    };

    const backToPreviousPage = () => {
      router.go(-1);
    };

    const openPurchaseWarningDialog = () => {
      DialogPurchaseWarning.value.openDialog();
    };

    const closePurchaseWarningDialog = () => {
      DialogPurchaseWarning.value.closeDialog();
    };

    watchEffect(() => {
      console.log(
        "watchEffect::paymentResult::" + JSON.stringify(paymentResult.value)
      );
      if (paymentResult.value != null) {
        if (paymentResult.value.result == "cancel") {
          closePurchaseWarningDialog();
          return;
        } else {
          //return_url or error_url -> move to processing page
          routerJS.push({
            name: "MfittBookingProcessing",
            params: { id: route.params.id },
            query: {
              coupon_id: route.query.coupon_id,
              payment_limited_express_ticket_id:
                route.query.payment_limited_express_ticket_id,
            },
          });
        }
      }
    });

    return {
      // creditCard,
      myLimitedExpressTicket,
      ticketPrice,
      isSaloon,
      ticketPurchase,
      backToPreviousPage,
      DialogCanNotPurchaseAfterCanceled,
      DialogLoading,
      DialogBadReception,
      DialogUnexpectedError,
      DialogDuringMaintenance,
      selectedPaymentMethod,
      paymentMethod,
      DialogPurchaseWarning,
      DialogGeneralPuchaseWarning,
    };
  },
};
</script>

<style>
.ticket-romancecar .content-block {
  width: 100%;
  padding: 0 0 16px;
}

.ticket-romancecar .content-block .block {
  display: table;
  font-size: 13px;
}

.foot-button-block {
  position: fixed;
  z-index: 99;
  left: 0;
  width: 90%;
  bottom: 0;
  background-color: #ffffff;
  padding: 15px 15px 20px 15px;
}

.caution-note-title {
  margin-bottom: 15px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: #ff3333;
}

.caution-note-text {
  font-weight: bold;
  text-align: center;
  line-height: 18px;
  font-size: 16px;
}

.caution-note,
.bottom-note {
  padding: 10px;
  margin-bottom: 150px;
}

.bottom-note {
  margin-top: 30px;
}
.caution-note-bottom {
  font-size: 16px;
  font-weight: bold;
  text-align: justify;
  color: #ff3333;
}
</style>
